import { FlagContext } from '@unleash/proxy-client-react';
import { useContext } from 'react';

export const useUnleashReady = (): boolean => {
  const context = useContext(FlagContext);
  if (!context) return true;
  return Boolean(context.flagsReady || context.flagsError);
};
